export const MRP_PO_BASE_FILTER_TOKEN = "approved_tscp_line";

const MRP_PO_DATE_FIELDS = new Set(["create_date", "mabd"]);

export function isMrpPoDateField(dateField) {
  return MRP_PO_DATE_FIELDS.has(String(dateField || "").trim().toLowerCase());
}

export function shouldApplyMrpPoBaseFilter({ dateField, poBaseFilterToken } = {}) {
  if (isMrpPoDateField(dateField)) return true;
  return String(poBaseFilterToken || "").trim().toLowerCase() === MRP_PO_BASE_FILTER_TOKEN;
}

